import React from 'react';
import { Accent } from '../Accent/Accent';
import { AdvertiserDisclosure, PRODUCT_TYPES } from '../AdvertiserDisclosure/AdvertiserDisclosure';
import { AuthorByline } from '../AuthorByline/AuthorByline';
import { Box } from '../Box/Box';
import { Column } from '../Columns/Column';
import { Columns } from '../Columns/Columns';
import { EditorialStandards } from '../EditorialStandards/EditorialStandards';
import { Text } from '../Text/Text';
import { Title } from '../Title/Title';
import { FeaturedImage } from './FeaturedImage';
export var ContentPageHeader = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var advertiserDisclosureShouldDelay = props.advertiserDisclosureShouldDelay,
      _props$advertiserDisc = props.advertiserDisclosureType,
      advertiserDisclosureType = _props$advertiserDisc === void 0 ? PRODUCT_TYPES.CREDIT_CARDS : _props$advertiserDisc,
      authoringDate = props.authoringDate,
      authors = props.authors,
      eyebrowText = props.eyebrowText,
      editorialStandardsType = props.editorialStandardsType,
      enableAnalytics = props.enableAnalytics,
      featuredImage = props.featuredImage,
      hideAdvertiserDisclosure = props.hideAdvertiserDisclosure,
      hideAuthorByline = props.hideAuthorByline,
      hideEditorialStandards = props.hideEditorialStandards,
      synopsis = props.synopsis,
      title = props.title,
      _props$width = props.width,
      width = _props$width === void 0 ? {
    mobile: 12,
    desktop: 8
  } : _props$width;
  var synopsisComponent = /*#__PURE__*/React.createElement(Box, {
    marginBottom: 3
  }, typeof synopsis === 'string' ? /*#__PURE__*/React.createElement(Text, null, synopsis) : synopsis);
  return /*#__PURE__*/React.createElement("header", {
    "data-currency": "ContentPageHeader",
    ref: ref
  }, /*#__PURE__*/React.createElement(Columns, null, /*#__PURE__*/React.createElement(Column, {
    width: width
  }, !hideAdvertiserDisclosure && /*#__PURE__*/React.createElement(Box, {
    marginBottom: 2
  }, /*#__PURE__*/React.createElement(AdvertiserDisclosure, {
    enableAnalytics: enableAnalytics,
    type: advertiserDisclosureType,
    shouldDelay: advertiserDisclosureShouldDelay
  })), eyebrowText && /*#__PURE__*/React.createElement(Box, {
    marginBottom: 2
  }, /*#__PURE__*/React.createElement(Accent, {
    size: "small"
  }, eyebrowText)), /*#__PURE__*/React.createElement(Box, {
    marginBottom: 3
  }, /*#__PURE__*/React.createElement(Title, {
    component: "h1"
  }, title)), synopsis && synopsisComponent, !hideAuthorByline && /*#__PURE__*/React.createElement(Box, {
    marginBottom: 3
  }, /*#__PURE__*/React.createElement(AuthorByline, {
    authoringDate: authoringDate,
    authors: authors
  })), featuredImage && /*#__PURE__*/React.createElement(Box, {
    marginBottom: 3
  }, /*#__PURE__*/React.createElement(FeaturedImage, {
    data: featuredImage
  })), !hideEditorialStandards && /*#__PURE__*/React.createElement(EditorialStandards, {
    type: editorialStandardsType
  }))));
});
ContentPageHeader.displayName = 'ContentPageHeader';